import React from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaArrowLeft,
  FaExclamationCircle,
  FaRedo,
} from "react-icons/fa";

const ServerError = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="card-board p-8">
          {/* Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-lg bg-red-100 mb-6">
            <FaExclamationCircle className="h-8 w-8 text-red-600" />
          </div>

          {/* Error Code */}
          <h1 className="heading-display text-6xl mb-4">500</h1>

          {/* Title */}
          <h2 className="heading-display text-2xl mb-4">
            Server Error
          </h2>

          {/* Description */}
          <p className="text-brand-muted mb-8 leading-relaxed">
            Something went wrong on our end. We're working to fix the problem.
            Please try again in a few moments.
          </p>

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={handleRefresh}
              className="w-full inline-flex items-center justify-center px-6 py-3 rounded-lg text-base font-display font-bold tracking-wide text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-gold-ink"
            >
              <FaRedo className="mr-2 h-5 w-5" />
              Try Again
            </button>

            <Link
              to="/"
              className="w-full inline-flex items-center justify-center px-6 py-3 rounded-lg text-base font-display font-bold tracking-wide text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-gold-ink"
            >
              <FaHome className="mr-2 h-5 w-5" />
              Go to Home
            </Link>

            <button
              onClick={() => window.history.back()}
              className="w-full inline-flex items-center justify-center px-6 py-3 rounded-lg text-base font-display font-bold tracking-wide text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-gold-ink"
            >
              <FaArrowLeft className="mr-2 h-5 w-5" />
              Go Back
            </button>
          </div>

          {/* Help Text */}
          <div className="mt-8 pt-6 border-t border-brand-charcoal/10">
            <p className="text-sm text-brand-muted mb-2">
              If the problem persists, please{" "}
              <Link
                to="/support/contact"
                className="text-brand-gold-ink hover:text-brand-charcoal underline"
              >
                contact support
              </Link>
            </p>
            <p className="text-xs text-gray-400">
              Error ID: {Date.now().toString(36)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServerError;
